/* eslint-disable import/prefer-default-export */
/* eslint-disable no-use-before-define */
/* eslint-disable max-len */
let Range;
let autocompletionEnabled = false;

export class TestEditor {
  constructor(monaco) {
    this.monaco = monaco;
    Range = monaco.Range;
    this.isGherkin = false;
  }

  enableGherkin() {
    this.isGherkin = true;
    enableSyntaxHighlighting(this.monaco);
  }

  enableAutocompletion(steps) {
    if (!autocompletionEnabled) {
      autocompletionEnabled = true;
      const { languages } = this.monaco;
      Range = this.monaco.Range;
      if (this.isGherkin) {
        languages.registerCompletionItemProvider('gherkin', getGherkinStepsCompletionProvider(steps.filter(s => s.id && !s['is-snippet'])));
        languages.registerCompletionItemProvider('gherkin', getSnippetsCompletionProvider(steps.filter(s => s.id && s['is-snippet'])));
      } else {
        languages.registerCompletionItemProvider('markdown', getMarkdownStepsCompletionProvider(steps.filter(s => s.id && !s['is-snippet'])));
        languages.registerCompletionItemProvider('markdown', getSnippetsCompletionProvider(steps.filter(s => s.id && s['is-snippet'])));
      }
    }
  }
}

function getMarkdownStepsCompletionProvider(steps) {
  let i = 0;
  const replaceFn = (match, p) => {
    i += 1;
    return `"\${${i}:${p}}"`;
  };

  return {
    triggerCharacters: ['*'],
    provideCompletionItems(model, position) {
      const rawTextUntilPosition = model.getValueInRange({
        startLineNumber: position.lineNumber,
        startColumn: 1,
        endLineNumber: position.lineNumber,
        endColumn: position.column,
      });

      let start = rawTextUntilPosition.match(/^(\s+)/g);
      start = start ? start[0].length + 1 : 0;

      const startPosition = rawTextUntilPosition.includes('*') ? rawTextUntilPosition.indexOf('*') + 3 : start;

      return {
        suggestions: steps.map(step => {
          i = 0;
          const insertText = (step.title || "").replace(/<(\w+)>/g, replaceFn);
          return {
            kind: 'snippet',
            label: step.title,
            insertText,
            insertTextRules: 4,
            range: new Range(
              position.lineNumber,
              startPosition,
              position.lineNumber,
              position.column + insertText.length,
            ),
          };
        }),
      };
    },
  };
}

function getGherkinStepsCompletionProvider(steps) {
  let i = 0;
  const replaceFn = (match, p) => {
    i += 1;
    return `"\${${i}:${p}}"`;
  };

  return {
    triggerCharacters: ['*'],
    provideCompletionItems(model, position) {
      const rawTextUntilPosition = model.getValueInRange({
        startLineNumber: position.lineNumber,
        startColumn: 1,
        endLineNumber: position.lineNumber,
        endColumn: position.column,
      });

      const textUntilPosition = rawTextUntilPosition.trim();

      if (textUntilPosition.length > 7) {
        return false;
      }
      if (textUntilPosition.startsWith('Scenario:')) {
        return false;
      }
      if (textUntilPosition.startsWith('Feature:')) {
        return false;
      }

      let start = rawTextUntilPosition.match(/^(\s+)/g);
      start = start ? start[0].length : 0;

      return {
        suggestions: steps.map(step => {
          return ['Given', 'When', 'Then', 'And'].map(keyword => {
            i = 0;
            return {
              kind: 'snippet',
              label: `${keyword} ${step.title}`,
              insertText: `${keyword} ${(step.title || "").replace(/<(\w+)>/g, replaceFn)}`,
              insertTextRules: 4,
              range: new Range(
                position.lineNumber,
                start + 1,
                position.lineNumber,
                position.column,
              ),
            };
          });
        }).flat(),
      };
    },
  };
}

function getSnippetsCompletionProvider(steps) {
  let i = 0;
  const replaceFn = (match, p) => {
    i += 1;
    return `"\${${i}:${p}}"`;
  };

  return {
    provideCompletionItems(model, position) {
      return {
        suggestions: steps.map(step => {
          const insertText = `${step.description.replace(/<(\w+)>/g, replaceFn)}\n`;

          return {
            kind: 'snippet',
            label: `${step.title}`,
            insertText,
            documentation: step.description,
            range: new Range(position.lineNumber, 1, position.lineNumber, position.column + insertText.length),
          };
        }),
      };
    },
  };
}

function enableSyntaxHighlighting(monaco) {
  monaco.languages.register({ id: 'gherkin' });

  monaco.languages.setMonarchTokensProvider('gherkin', {
    tokenizer: {
      root: [
        [
          /^\s*(예|시나리오 개요|시나리오|배경|背景|場景大綱|場景|场景大纲|场景|劇本大綱|劇本|例子|例|テンプレ|シナリオテンプレート|シナリオテンプレ|シナリオアウトライン|シナリオ|サンプル|سيناريو مخطط|سيناريو|امثلة|الخلفية|תרחיש|תבנית תרחיש|רקע|דוגמאות|Тарих|Сценарій|Сценарији|Сценарио|Сценарий структураси|Сценарий|Структура сценарію|Структура сценарија|Структура сценария|Скица|Рамка на сценарий|Примери|Пример|Приклади|Предыстория|Предистория|Позадина|Передумова|Основа|Мисоллар|Концепт|Контекст|Значения|Örnekler|Założenia|Wharrimean is|Voorbeelden|Variantai|Tình huống|The thing of it is|Tausta|Taust|Tapausaihio|Tapaus|Tapaukset|Szenariogrundriss|Szenario|Szablon scenariusza|Stsenaarium|Struktura scenarija|Skica|Skenario konsep|Skenario|Situācija|Senaryo taslağı|Senaryo|Scénář|Scénario|Schema dello scenario|Scenārijs pēc parauga|Scenārijs|Scenár|Scenariusz|Scenariul de şablon|Scenariul de sablon|Scenariu|Scenarios|Scenario Outline|Scenario Amlinellol|Scenario|Scenarijus|Scenariji|Scenarijaus šablonas|Scenarijai|Scenarij|Scenarie|Rerefons|Raamstsenaarium|Příklady|Példák|Príklady|Przykłady|Primjeri|Primeri|Primer|Pozadí|Pozadina|Pozadie|Plan du scénario|Plan du Scénario|Piemēri|Pavyzdžiai|Paraugs|Osnova scénáře|Osnova|Náčrt Scénáře|Náčrt Scenáru|Mate|MISHUN SRSLY|MISHUN|Kịch bản|Kontext|Konteksts|Kontekstas|Kontekst|Koncept|Khung tình huống|Khung kịch bản|Juhtumid|Háttér|Grundlage|Geçmiş|Forgatókönyv vázlat|Forgatókönyv|Exemplos|Exemples|Exemplele|Exempel|Examples|Esquema do Cenário|Esquema do Cenario|Esquema del escenario|Esquema de l'escenari|Esempi|Escenario|Escenari|Enghreifftiau|Eksempler|Ejemplos|EXAMPLZ|Dữ liệu|Dis is what went down|Dasar|Contoh|Contexto|Contexte|Contesto|Condiţii|Conditii|Cobber|Cenário|Cenario|Cefndir|Bối cảnh|Blokes|Beispiele|Bakgrunn|Bakgrund|Baggrund|Background|B4|Antecedents|Antecedentes|All y'all|Achtergrond|Abstrakt Scenario|Abstract Scenario):/,
          'keyword',
        ],
        [/^\s*#.*/, 'comment'],
        ['<[a-zA-Z0-9 _-]*>', 'variable'],
        [/^\s*(기능|機能|功能|フィーチャ|خاصية|תכונה|Функціонал|Функционалност|Функционал|Особина|Могућност|Özellik|Właściwość|Tính năng|Savybė|Požiadavka|Požadavek|Osobina|Ominaisuus|Omadus|OH HAI|Mogućnost|Mogucnost|Jellemző|Fīča|Funzionalità|Funktionalität|Funkcionalnost|Funkcionalitāte|Funcționalitate|Functionaliteit|Functionalitate|Funcionalitat|Funcionalidade|Fonctionnalité|Fitur|Ability|Business Need|Feature|Ability|Egenskap|Egenskab|Crikey|Característica|Arwedd):/, 'keyword'],

        [/^\s*(En |و |Y |E |Եվ |Ya |Too right |Və |Həm |A |И |而且 |并且 |同时 |並且 |同時 |Ak |Epi |A také |Og |😂 |And |Kaj |Ja |Et que |Et qu' |Et |და |Und |Και |અને |וגם |और |तथा |És |Dan |Agus |かつ |Lan |ಮತ್ತು |'ej |latlh |그리고 |AN |Un |Ir |an |a |Мөн |Тэгээд |Ond |7 |ਅਤੇ |Aye |Oraz |Si |Și |Şi |К тому же |Также |An |A tiež |A taktiež |A zároveň |In |Ter |Och |மேலும் |மற்றும் |Һәм |Вә |మరియు |และ |Ve |І |А також |Та |اور |Ва |Và |Maar |لكن |Pero |Բայց |Peru |Yeah nah |Amma |Ancaq |Ali |Но |Però |但是 |Men |Ale |😔 |But |Sed |Kuid |Mutta |Mais que |Mais qu' |Mais |მაგ­რამ |Aber |Αλλά |પણ |אבל |पर |परन्तु |किन्तु |De |En |Tapi |Ach |Ma |しかし |但し |ただし |Nanging |Ananging |ಆದರೆ |'ach |'a |하지만 |단 |BUT |Bet |awer |mä |No |Tetapi |Гэхдээ |Харин |Ac |ਪਰ |اما |Avast! |Mas |Dar |А |Иначе |Buh |Али |Toda |Ampak |Vendar |ஆனால் |Ләкин |Әмма |కాని |แต่ |Fakat |Ama |Але |لیکن |Лекин |Бирок |Аммо |Nhưng |Ond |Dan |اذاً |ثم |Alavez |Allora |Antonces |Ապա |Entós |But at the end of the day I reckon |O halda |Zatim |То |Aleshores |Cal |那么 |那麼 |Lè sa a |Le sa a |Onda |Pak |Så |🙏 |Then |Do |Siis |Niin |Alors |Entón |Logo |მაშინ |Dann |Τότε |પછી |אז |אזי |तब |तदा |Akkor |Þá |Maka |Ansin |ならば |Njuk |Banjur |ನಂತರ |vaj |그러면 |DEN |Tad |Tada |dann |Тогаш |Togash |Kemudian |Тэгэхэд |Үүний дараа |Tha |Þa |Ða |Tha the |Þa þe |Ða ðe |ਤਦ |آنگاه |Let go and haul |Wtedy |Então |Entao |Atunci |Затем |Тогда |Dun |Den youse gotta |Онда |Tak |Potom |Nato |Potem |Takrat |Entonces |அப்பொழுது |Нәтиҗәдә |అప్పుడు |ดังนั้น |O zaman |Тоді |پھر |تب |Унда |Thì |Yna |Wanneer |متى |عندما |Cuan |Եթե |Երբ |Cuando |It's just unbelievable |Əgər |Nə vaxt ki |Kada |Когато |Quan |当 |當 |Lè |Le |Kad |Když |Når |Als |🎬 |When |Se |Kui |Kun |Quand |Lorsque |Lorsqu' |Cando |როდესაც |Wenn |Όταν |ક્યારે |כאשר |जब |कदा |Majd |Ha |Amikor |Þegar |Ketika |Nuair a |Nuair nach |Nuair ba |Nuair nár |Quando |もし |Manawa |Menawa |ಸ್ಥಿತಿಯನ್ನು |qaSDI' |만일 |만약 |WEN |Ja |Kai |wann |Кога |Koga |Apabila |Хэрэв |Tha |Þa |Ða |ਜਦੋਂ |هنگامی |Blimey! |Jeżeli |Jeśli |Gdy |Kiedy |Cand |Când |Когда |Если |Wun |Youse know like when |Када |Кад |Keď |Ak |Ko |Ce |Če |Kadar |När |எப்போது |Әгәр |ఈ పరిస్థితిలో |เมื่อ |Eğer ki |Якщо |Коли |جب |Агар |Khi |Pryd |Gegewe |بفرض |Dau |Dada |Daus |Dadas |Դիցուք |Dáu |Daos |Daes |Y'know |Tutaq ki |Verilir |Dato |Дадено |Donat |Donada |Atès |Atesa |假如 |假设 |假定 |假設 |Sipoze |Sipoze ke |Sipoze Ke |Zadan |Zadani |Zadano |Pokud |Za předpokladu |Givet |Gegeven |Stel |😐 |Given |Donitaĵo |Komence |Eeldades |Oletetaan |Soit |Etant donné que |Etant donné qu' |Etant donné |Etant donnée |Etant donnés |Etant données |Étant donné que |Étant donné qu' |Étant donné |Étant donnée |Étant donnés |Étant données |Dado |Dados |მოცემული |Angenommen |Gegeben sei |Gegeben seien |Δεδομένου |આપેલ છે |בהינתן |अगर |यदि |चूंकि |Amennyiben |Adott |Ef |Dengan |Cuir i gcás go |Cuir i gcás nach |Cuir i gcás gur |Cuir i gcás nár |Data |Dati |Date |前提 |Nalika |Nalikaning |ನೀಡಿದ |ghu' noblu' |DaH ghu' bejlu' |조건 |먼저 |I CAN HAZ |Kad |Duota |ugeholl |Дадена |Dadeno |Dadena |Diberi |Bagi |Өгөгдсөн нь |Анх |Gitt |Thurh |Þurh |Ðurh |ਜੇਕਰ |ਜਿਵੇਂ ਕਿ |با فرض |Gangway! |Zakładając |Mając |Zakładając, że |Date fiind |Dat fiind |Dată fiind |Dati fiind |Dați fiind |Daţi fiind |Допустим |Дано |Пусть |Givun |Youse know when youse got |За дато |За дате |За дати |Za dato |Za date |Za dati |Pokiaľ |Za predpokladu |Dano |Podano |Zaradi |Privzeto |கொடுக்கப்பட்ட |Әйтик |చెప్పబడినది |กำหนดให้ |Diyelim ki |Припустимо |Припустимо, що |Нехай |اگر |بالفرض |فرض کیا |Агар |Biết |Cho |Anrhegedig a |\\* )/, 'keyword'],
        [/^\s*\|/, '@rematch', '@table_header'],
        // numbers
        [/\d*\.\d+([eE][-+]?\d+)?/, 'number.float'],
        [/0[xX][0-9a-fA-F]+/, 'number.hex'],
        [/\s\d+/, 'number'],

        // strings
        // strings
        [/"([^"\\]|\\.)*$/, 'string.invalid'], // non-teminated string
        [/"/, { token: 'string.quote', bracket: '@open', next: '@string' }],

        // code block (3 tilde)
        [/^\s*```\s*$/, { token: 'string', next: '@codeblock' }],
      ],

      codeblock: [
        [/^\s*```\s*$/, { token: 'string', next: '@pop' }],
      ],

      string: [
        [/[^\\"]+/, 'string'],
        [/\\./, 'string.escape.invalid'],
        [/"/, { token: 'string.quote', bracket: '@close', next: '@pop' }],
      ],

      table_header: [
        { include: '@table_common' },
        [/[^|]+/, 'keyword.table.header'], // table header
      ],

      table_body: [
        { include: '@table_common' },
      ],

      table_common: [
        [/\s*[-:]+\s*/, { token: 'variable', switchTo: 'table_body' }], // header-divider
        [/^\s*\|/, 'keyword.table.left'], // opening |
        [/^\s*[^|]/, '@rematch', '@pop'], // exiting
        [/^\s*$/, '@rematch', '@pop'], // exiting
        [/\|/, {
          cases: {
            '@eos': 'keyword.table.right', // closing |
            '@default': 'keyword.table.middle', // inner |
          },
        }],
      ],
    },
  });
}
